<template>
  <div>
    <div class="fix-wrapper">
      <breadcrumb
        :crumbs="[$t('menu.products'), $t('text.create')]"
      ></breadcrumb>
      <div class="container">
        <el-form
          ref="productForm"
          :model="product"
          label-width="80px"
          size="small"
        >
          <div class="pd20">
            <fieldset class="mgb15">
              <legend>
                {{ $t("text.baseInfo") }}
              </legend>
              <el-row>
                <el-col :span="8">
                  <el-form-item
                    :label="$t('product.productNo')"
                    :prop="'productNo'"
                    :rules="[
                      {
                        required: true,
                        validator: validateProductNo,
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input size="small" v-model.trim="product.productNo" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('product.name')" :prop="'name'">
                    <el-input size="small" v-model.trim="product.name" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('product.life')" :prop="'life'">
                    <el-input size="small" v-model.trim="product.life">
                      <template slot="append">{{ $t("text.month") }}</template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item
                    :label="$t('product.category')"
                    :prop="'categoryId'"
                    :rules="[
                      {
                        required: true,
                        message: $t('rules.required', [$t('product.category')]),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-select
                      size="small"
                      v-model="product.categoryId"
                      clearable
                      filterable
                      @change="selsectCategory"
                    >
                      <el-option
                        v-for="category in categories"
                        :key="category.id"
                        :label="category.name"
                        :value="category.id"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('product.brand')" :prop="'brand'">
                    <el-select
                      size="small"
                      v-model="product.brandId"
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="brand in brands"
                        :key="brand.id"
                        :label="brand.name"
                        :value="brand.id"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    :label="$t('product.unit')"
                    :prop="'unit'"
                    :rules="[
                      {
                        required: true,
                        message: $t('rules.required', [$t('product.unit')]),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-select
                      size="small"
                      v-model="product.unit"
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="unit in units"
                        :key="unit.id"
                        :label="unit.name"
                        :value="unit.name"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item
                    :label="$t('product.salesPrice')"
                    :prop="'salesPrice'"
                    :rules="[
                      {
                        required: true,
                        message: $t('rules.required', [
                          $t('product.salesPrice'),
                        ]),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input size="small" v-model.trim="product.salesPrice" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    :label="$t('product.costPrice')"
                    :prop="'costPrice'"
                    :rules="[
                      {
                        required: true,
                        message: $t('rules.required', [
                          $t('product.costPrice'),
                        ]),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input size="small" v-model.trim="product.costPrice" />
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item
                    :label="$t('product.rentPrice')"
                    :prop="'rentPrice'"
                    :rules="[
                      {
                        required: true,
                        message: $t('rules.required', [
                          $t('product.rentPrice'),
                        ]),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input size="small" v-model.trim="product.rentPrice" />
                  </el-form-item>
                </el-col>
              </el-row>
            </fieldset>
            <fieldset v-if="suppliers.length !== 0" class="mgb15">
              <legend>{{ $t("product.productSupplier") }}</legend>
              <el-row
                v-for="(productSupplier, psIndex) of product.productSuppliers"
                :key="psIndex"
              >
                <el-col :span="8">
                  <el-form-item :label="$t('menu.suppliers')">
                    <el-select
                      size="small"
                      v-model="productSupplier.supplierId"
                      @change="selectProductSupplier(psIndex)"
                    >
                      <el-option
                        v-for="supplier in suppliers"
                        :key="supplier.id"
                        :label="supplier.name"
                        :value="supplier.id"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label-width="90px"
                    :label="$t('product.supplierProductNo')"
                  >
                    <el-input
                      size="small"
                      v-model.trim="productSupplier.productNo"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('text.remark')">
                    <el-input
                      size="small"
                      v-model.trim="productSupplier.remark"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <div class="center">
                <el-button
                  v-if="product.productSuppliers.length < 10"
                  type="info"
                  @click="addMoreProductSupplier"
                  size="mini"
                  plain
                  round
                  >+ {{ $t("text.more") }}</el-button
                >
                <span v-else class="orange">
                  {{ $t("prompt.addMorePrompt") }}
                </span>
              </div>
            </fieldset>
            <el-row :gutter="10">
              <el-col :span="15">
                <fieldset class="mgb15">
                  <legend>
                    {{ $t("product.color") }}
                    <i
                      class="el-icon-circle-plus green mgl5"
                      @click="addColor"
                    />
                    <el-input
                      v-if="colorsAll.length != 0"
                      class="mgl10"
                      size="mini"
                      style="width: 120px"
                      v-model.trim="searchColor"
                      :placeholder="'颜色 搜索'"
                      @input="searchColorChange"
                    />
                  </legend>
                  <div v-if="colors.length != 0">
                    <el-checkbox
                      class="mgb10"
                      v-model="checkAllColors"
                      :indeterminate="isIndeterminateColors"
                      @change="handleCheckAllColorsChange"
                      >{{ $t("action.checkAll") }}</el-checkbox
                    >
                    <el-checkbox-group
                      size="small"
                      v-model="checkedColors"
                      @change="handleCheckedColorsChange"
                    >
                      <el-checkbox
                        v-for="color in colors"
                        :key="color.name"
                        :label="color.name"
                        style="width: 20%"
                      >
                        <raw-html-limit-number
                          :content="color.name"
                          :number="8"
                        />
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                </fieldset>
                <fieldset class="mgb15">
                  <legend>
                    {{ $t("product.size") }}
                    <i
                      class="el-icon-circle-plus green mgl5"
                      @click="addSize"
                    />
                    <el-input
                      v-if="sizesAll.length != 0"
                      class="mgl10"
                      size="mini"
                      style="width: 120px"
                      v-model.trim="searchSize"
                      :placeholder="'规格 搜索'"
                      @input="searchSizeChange"
                    />
                  </legend>
                  <div v-if="sizes.length != 0">
                    <el-checkbox
                      v-model="checkAllSizes"
                      :indeterminate="isIndeterminateSizes"
                      class="mgb10"
                      @change="handleCheckAllSizesChange"
                      >{{ $t("action.checkAll") }}</el-checkbox
                    >
                    <el-checkbox-group
                      v-model="checkedSizes"
                      @change="handleCheckedSizesChange"
                    >
                      <el-checkbox
                        v-for="size in sizes"
                        :key="size.name"
                        :label="size.name"
                        style="width: 20%"
                      >
                        <raw-html-limit-number
                          :content="size.name"
                          :number="8"
                        />
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                </fieldset>
              </el-col>
              <el-col :span="9">
                <fieldset class="mgb15">
                  <legend>
                    {{ $t("product.images") }}
                    <svg-icon icon-class="link" @click="linkImage" />
                  </legend>
                  <dropzone v-model="product.images" multiple />
                </fieldset>
              </el-col>
            </el-row>
            <fieldset class="mgb15">
              <legend>{{ $t("product.introduction") }}</legend>
              <el-input
                v-model="product.introduction"
                type="textarea"
                :rows="2"
              />
              <el-row class="mgt10">
                <el-col :span="8">
                  <el-form-item label-width="10px">
                    <el-checkbox v-model="product.initInvDF">
                      同时初始化现货
                    </el-checkbox>
                  </el-form-item>
                </el-col>
              </el-row>
            </fieldset>
            <fieldset class="mgb15" v-if="product.initInvDF == true">
              <legend>
                {{ $t("menu.inventories") }}
                <small class="orange">数量不填忽略该单元格</small>
              </legend>
              <table class="matrix" cellspacing="5" v-if="matrixShow">
                <tr v-for="(row, i) in matrix" :key="i">
                  <td v-for="(cell, j) in row" :key="j">
                    <span v-if="i == 0 || j == 0">
                      <span v-if="i == 0">{{ cell.name }}</span>
                      <span v-if="j == 0">{{ cell }}</span>
                    </span>
                    <el-input
                      size="small"
                      class="quantity-input"
                      :placeholder="'现货数量'"
                      v-model="matrix[i][j]"
                      v-else
                    ></el-input>
                  </td>
                </tr>
              </table>
              <div class="noData" v-else>请先选择颜色、规格</div>
            </fieldset>
          </div>
          <div class="form-footer">
            <el-button
              type="primary"
              size="medium"
              plain
              :loading="saveDoing"
              @click="saveSubmit"
              >{{ $t("text.submit") }}</el-button
            >
            <back-button />
          </div>
        </el-form>
      </div>
      <el-dialog
        :title="$t('action.linkImage')"
        :visible.sync="linkImageDF"
        :close-on-click-modal="false"
        width="50%"
      >
        <el-form ref="linkImageObjForm" :model="linkImageObj">
          <el-form-item
            :prop="'linkImageStr'"
            :rules="[
              {
                required: true,
                message: $t('rules.required', [$t('action.linkImage')]),
                trigger: 'blur',
              },
            ]"
          >
            <el-input
              size="small"
              v-model.trim="linkImageObj.linkImageStr"
              :placeholder="$t('prompt.linkImageExplain')"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
            />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            plain
            :loading="linkImageDoing"
            size="small"
            @click="linkImageSubmit"
            >{{ $t("text.submit") }}</el-button
          >
          <el-button size="small" @click="linkImageDF = false">{{
            $t("text.close")
          }}</el-button>
        </div>
      </el-dialog>

      <el-dialog
        :append-to-body="true"
        :title="$t('rules.create', [$t('product.color')])"
        :close-on-click-modal="false"
        :visible.sync="addColorDF"
        width="30%"
      >
        <el-form ref="addColorForm" :model="addColorObj">
          <el-form-item
            :prop="'name'"
            :rules="[
              { required: true, validator: validateColor, trigger: 'blur' },
            ]"
          >
            <el-input
              size="small"
              v-model.trim="addColorObj.name"
              :placeholder="$t('text.name')"
            />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            plain
            :loading="addColorSubmitDoing"
            size="small"
            @click="addColorSubmit"
            >{{ $t("text.submit") }}</el-button
          >
          <el-button size="small" @click="addColorDF = false">{{
            $t("text.close")
          }}</el-button>
        </div>
      </el-dialog>
      <el-dialog
        :append-to-body="true"
        :title="$t('rules.create', [$t('product.size')])"
        :close-on-click-modal="false"
        :visible.sync="addSizeDF"
        width="30%"
      >
        <el-form ref="addSizeForm" :model="addSizeObj">
          <el-form-item
            :prop="'name'"
            :rules="[
              { required: true, validator: validateSize, trigger: 'blur' },
            ]"
          >
            <el-input
              size="small"
              v-model.trim="addSizeObj.name"
              :placeholder="$t('text.name')"
            />
          </el-form-item>
          <el-form-item>
            <el-input
              size="small"
              v-model.trim="addSizeObj.explain"
              :placeholder="$t('text.explain')"
            />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            plain
            :loading="addSizeSubmitDoing"
            size="small"
            @click="addSizeSubmit"
            >{{ $t("text.submit") }}</el-button
          >
          <el-button size="small" @click="addSizeDF = false">{{
            $t("text.close")
          }}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import BackButton from "@/components/BackButton";
import TinymceEditor from "@/components/TinymceEditor";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import Dropzone from "@/components/Dropzone";

import Product from "@/api/product.js";
import Category from "@/api/category.js";
import Size from "@/api/size.js";
import Color from "@/api/color.js";
import Brand from "@/api/brand";
import Unit from "@/api/unit";
import Supplier from "@/api/supplier";
import Shop from "@/api/shop";

function bulidProductSupplier() {
  return {
    supplierId: null,
    productNo: null,
    defaultSupplier: false,
    remark: null,
  };
}
export default {
  mixins: [page],
  components: {
    BackButton,
    TinymceEditor,
    Dropzone,
    RawHtmlLimitNumber,
  },
  data() {
    var validateProductNo = (rule, value, callback) => {
      const self = this;
      if (value === null || value === "") {
        callback(
          new Error(this.$t("rules.required", [this.$t("product.productNo")]))
        );
        return;
      }
      Product.findByProductNo({ productNo: value }).then(function (res) {
        if (res.data.code === 200) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("product.productNo")]))
          );
        } else {
          callback();
        }
      });
    };
    var validateColor = (rule, value, callback) => {
      const self = this;
      if (value === null) {
        callback(
          new Error(this.$t("rules.required", [this.$t("menu.colors")]))
        );
        return;
      }
      if (self.colorsAll.find((s) => s.name === value) != null) {
        callback(new Error(this.$t("rules.exist", [this.$t("menu.colors")])));
      } else {
        callback();
      }
    };
    var validateSize = (rule, value, callback) => {
      const self = this;
      if (value === null) {
        callback(new Error(this.$t("rules.required", [this.$t("menu.sizes")])));
        return;
      }
      if (self.sizesAll.find((s) => s.name === value) != null) {
        callback(new Error(this.$t("rules.exist", [this.$t("menu.sizes")])));
      } else {
        callback();
      }
    };
    return {
      Util: Util,
      validateProductNo: validateProductNo,
      product: {
        productNo: null,
        unit: null,
        categoryId: null,
        brandId: null,
        images: null,
        salesPrice: null,
        costPrice: null,
        rentPrice: null,
        colorJson: null,
        sizeJson: null,
        purchaseUrl: null,
        type: "product",
        remark: null,
        life: null,
        productSuppliers: [bulidProductSupplier()],
        inventorys: [],
        initInvDF: true,
      },
      saveDoing: false,

      categories: [],
      sizes: [],
      sizesAll: [],
      colors: [],
      colorsAll: [],
      units: [],
      brands: [],
      suppliers: [],
      shops: [],
      // 颜色
      isIndeterminateColors: false,
      checkedColors: [],
      checkAllColors: false,
      searchColor: null,
      // 尺码
      isIndeterminateSizes: false,
      checkedSizes: [],
      checkAllSizes: false,
      searchSize: null,
      // 图片链接
      linkImageDF: false,
      linkImageObj: {
        linkImageStr: null,
      },
      linkImageDoing: false,
      // 新增颜色
      validateColor: validateColor,
      addColorDF: false,
      addColorObj: { name: null },
      addColorSubmitDoing: false,
      // 新增尺码
      validateSize: validateSize,
      addSizeDF: false,
      addSizeObj: { name: null, explain: null },
      addSizeSubmitDoing: false,
      //
      matrix: [],
    };
  },
  computed: {
    matrixShow() {
      return this.matrix.length > 1 && this.matrix[0].length > 1;
    },
  },
  created() {
    const self = this;
    axios
      .all([
        Category.productCategory(),
        Size.findByTenantId(),
        Color.findByTenantId(),
        Unit.findByTenantId(),
        Brand.findByTenantId(),
        Supplier.findByTenantId(),
        Shop.findByTenantId(),
      ])
      .then(
        axios.spread(function (
          categories,
          sizes,
          colors,
          units,
          brands,
          suppliers,
          shops
        ) {
          if (categories.status === 200) {
            self.categories = categories.data;
          } else {
            self.sysError();
          }
          if (sizes.status === 200) {
            self.sizes = sizes.data;
            self.sizesAll = sizes.data;
          } else {
            self.sysError();
          }
          if (colors.status === 200) {
            self.colors = colors.data;
            self.colorsAll = colors.data;
          } else {
            self.sysError();
          }
          if (units.status === 200) {
            self.units = units.data;
          } else {
            self.sysError();
          }
          if (brands.status === 200) {
            self.brands = brands.data;
          } else {
            self.sysError();
          }
          if (suppliers.status === 200) {
            self.suppliers = suppliers.data;
          } else {
            self.sysError();
          }
          if (shops.status === 200) {
            self.shops = shops.data;
          } else {
            self.sysError();
          }
        })
      );
  },
  methods: {
    buildMatrix() {
      const self = this;
      if (self.checkedColors.length == 0 || self.checkedSizes.length == 0) {
        self.matrix = [];
        return;
      }
      let mt = [];
      let headerRow = ["#"].concat(
        this.shops.map((s) => {
          return { id: s.id, name: s.name };
        })
      );
      mt.push(headerRow);
      self.checkedColors.forEach(function (color, colorIndex) {
        self.checkedSizes.forEach(function (size, sizeIndex) {
          let rowN = new Array(headerRow.length);
          rowN[0] = color + " -- " + size;
          mt.push(rowN);
          self.matrix = mt;
        });
      });
    },
    //供应商
    addMoreProductSupplier() {
      this.product.productSuppliers.push(bulidProductSupplier());
    },
    selectProductSupplier(index) {
      if (
        this.product.productSuppliers[index].supplierId != null &&
        this.product.productSuppliers[index].supplierId != ""
      ) {
        if (
          this.product.productSuppliers.filter(
            (ps) =>
              ps.supplierId == this.product.productSuppliers[index].supplierId
          ).length > 1
        ) {
          this.$message({
            message: this.$t("rules.exist", [this.$t("menu.suppliers")]),
            type: "warning",
          });
          this.product.productSuppliers[index].supplierId = null;
        }
      }
    },
    // 新增尺码
    addSize() {
      this.addSizeObj.name = null;
      this.addSizeObj.explain = null;
      this.addSizeSubmitDoing = false;
      this.addSizeDF = true;
    },
    addSizeSubmit() {
      const self = this;
      this.$refs.addSizeForm.validate((valid) => {
        if (valid) {
          self.addSizeSubmitDoing = true;
          this.addSizeObj.name = this.addSizeObj.name.trim();
          Size.insertBatch([self.addSizeObj]).then(function (res) {
            self.addSizeSubmitDoing = false;
            self.addSizeDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.addSuccess"),
                type: "success",
              });
              self.getSizes();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    getSizes() {
      const self = this;
      Size.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.sizes = res.data;
          self.sizesAll = res.data;
        } else {
          self.sysError();
        }
      });
    },
    // 新增颜色
    addColor() {
      this.addColorObj.name = null;
      this.addColorObj.image = null;
      this.addColorSubmitDoing = false;
      this.addColorDF = true;
    },
    addColorSubmit() {
      const self = this;
      this.$refs.addColorForm.validate((valid) => {
        if (valid) {
          self.addColorSubmitDoing = true;
          Color.insertBatch([this.addColorObj]).then(function (res) {
            self.addColorSubmitDoing = false;
            self.addColorDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.addSuccess"),
                type: "success",
              });
              self.getColors();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    getColors() {
      const self = this;
      Color.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.colors = res.data;
          self.colorsAll = res.data;
        } else {
          self.sysError();
        }
      });
    },
    //
    saveSubmit() {
      const self = this;
      this.$refs.productForm.validate((valid) => {
        if (valid) {
          if (!Util.regexPrice(self.product.salesPrice)) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("product.salesPrice")]),
              type: "warning",
            });
            return;
          }
          if (!Util.regexPrice(self.product.costPrice)) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("product.costPrice")]),
              type: "warning",
            });
            return;
          }
          if (!Util.regexPrice(self.product.rentPrice)) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("product.rentPrice")]),
              type: "warning",
            });
            return;
          }

          self.product.inventorys = [];
          const productSuppliersFilter = JSON.parse(
            JSON.stringify(self.product.productSuppliers)
          ).filter((ps) => ps.supplierId != null);
          if (productSuppliersFilter.length != 0) {
            productSuppliersFilter[0].defaultSupplier = true;
            self.product.productSuppliers = productSuppliersFilter;
          } else {
            self.product.productSuppliers = [];
          }
          self.product.colorJson = JSON.stringify(self.checkedColors);
          self.product.sizeJson = JSON.stringify(self.checkedSizes);

          if (self.product.initInvDF == false) {
            self.saveDoing = true;
            Product.create(self.product).then(function (res) {
              self.saveDoing = false;
              if (res.status === 200) {
                self.sysResult(res.data);
                self.$router.push({ name: "pdmProducts" });
              } else {
                self.sysError();
              }
            });
          } else {
            if (self.generateInvs().length == 0) {
              self.$message({
                message: "至少填写一条现货信息",
                type: "warning",
              });
              return;
            }
            self.product.inventorys = self.generateInvs();
            self.saveDoing = true;
            Product.insertAndInitInv(self.product).then(function (res) {
              self.saveDoing = false;
              if (res.status === 200) {
                self.sysResult(res.data);
                self.$router.push({ name: "pdmProducts" });
              } else {
                self.sysError();
              }
            });
          }
        } else {
          return false;
        }
      });
    },

    generateInvs() {
      let self = this;
      let os = [];
      let shops = [];
      for (let i = 0; i < self.matrix.length; i++) {
        if (i == 0) {
          if (self.matrix[0].length > 1) {
            shops = this.matrix[0];
          }
          continue;
        }
        let row = this.matrix[i];
        for (let j = 0; j < row.length; j++) {
          if (j == 0) {
            continue;
          }
          if (self.matrix[i][j] && self.matrix[i][j] != "") {
            os.push({
              shopId: shops[j].id,
              color: self.matrix[i][0].split("--")[0],
              size: self.matrix[i][0].split("--")[1],
              quantity: self.matrix[i][j],
            });
          }
        }
      }
      // console.log("this os: ", os);
      return os;
    },
    // 图片链接
    linkImage() {
      this.linkImageDF = true;
      this.linkImageObj.linkImageStr = null;
    },
    linkImageSubmit() {
      const self = this;
      self.$refs.linkImageObjForm.validate((valid) => {
        if (valid) {
          const linkImageArr = this.linkImageObj.linkImageStr.split("\n");
          const linkImageArrFilter = linkImageArr.filter((a) => a != null);
          if (self.product.images == null) {
            self.product.images = linkImageArrFilter.join(";");
          } else {
            self.product.images =
              self.product.images + ";" + linkImageArrFilter.join(";");
          }
          self.linkImageDF = false;
        } else {
          return false;
        }
      });
    },

    // 颜色
    handleCheckAllColorsChange(val) {
      this.checkedColors = val ? this.colors.map((c) => c.name) : [];
      this.buildMatrix();
    },
    handleCheckedColorsChange(value) {
      const checkedCount = value.length;
      this.checkAllColors = checkedCount === this.colors.length;
      this.isIndeterminateColors =
        checkedCount > 0 && checkedCount < this.colors.length;
      this.buildMatrix();
    },
    searchColorChange() {
      let newSearchColor = this.searchColor.toUpperCase();
      this.colors = this.colorsAll.filter(
        (c) => c.name.toUpperCase().indexOf(newSearchColor) != -1
      );
    },
    // 尺码
    handleCheckAllSizesChange(val) {
      this.checkedSizes = val ? this.sizes.map((s) => s.name) : [];
      this.buildMatrix();
    },

    handleCheckedSizesChange(value) {
      const checkedCount = value.length;
      this.checkAllSizes =
        checkedCount === this.sizes.map((s) => s.name).length;
      this.isIndeterminateSizes =
        checkedCount > 0 && checkedCount < this.sizes.map((s) => s.name).length;
      this.buildMatrix();
    },
    searchSizeChange() {
      this.sizes = this.sizesAll.filter(
        (c) => c.name.toUpperCase().indexOf(this.searchSize.toUpperCase()) != -1
      );
    },

    selsectCategory() {
      const self = this;
      if (self.product.categoryId === "" || self.product.categoryId == null) {
        self.product.categoryId = null;
        self.sizes = self.sizesAll;
        return;
      }
      const selsectCategoryObj = self.categories.find(
        (c) => c.id === self.product.categoryId
      );
      if (
        selsectCategoryObj &&
        selsectCategoryObj.sizes != null &&
        selsectCategoryObj.sizes.length !== 0
      ) {
        self.sizes = selsectCategoryObj.sizes;
      } else {
        self.sizes = self.sizesAll;
      }
      if (self.checkedSizes.length !== 0) {
        self.checkedSizes = self.checkedSizes.filter(
          (c) => self.sizes.find((s) => s.name === c) != null
        );
      }
    },
  },
};
</script>

<style scoped>
table.matrix td {
  font-size: 13px;
  color: #606266;
  font-weight: bold;
  width: 100px;
}
table.matrix tr:first-child td,
table.matrix tr td:first-child {
  background: #f8f8f9;
  padding: 7px 10px;
}
</style>